import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const ExitModal = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useLanguage();

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-6">
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onCancel}
            className="absolute inset-0 bg-slate-950/80 backdrop-blur-sm"
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            className="relative w-full max-w-sm bg-slate-800 rounded-3xl p-6 shadow-2xl border border-slate-700 overflow-hidden"
          >
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-blue-500 to-emerald-500" />
            
            <div className="flex flex-col items-center text-center">
              <div className="w-16 h-16 bg-slate-700 rounded-2xl flex items-center justify-center mb-4 text-blue-400">
                <SafeIcon icon={FiIcons.FiLogOut} className="text-3xl" />
              </div>
              
              <h3 className="text-xl font-bold text-white mb-2">
                {t('exitTitle')}
              </h3>
              
              <p className="text-slate-300 text-sm mb-8 leading-relaxed">
                {t('exitConfirm')}
              </p>
              
              <div className="grid grid-cols-2 gap-3 w-full">
                <button
                  onClick={onCancel}
                  className="px-6 py-3 rounded-xl bg-slate-700 text-white font-bold text-sm hover:bg-slate-600 active:scale-95 transition-all"
                >
                  {t('exitNo')}
                </button>
                <button
                  onClick={onConfirm}
                  className="px-6 py-3 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 text-white font-bold text-sm shadow-lg shadow-blue-900/20 active:scale-95 transition-all"
                >
                  {t('exitYes')}
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default ExitModal;